import * as tslib_1 from "tslib";
import _ from 'lodash';
import { VIEWER_SCRIPT_DSN } from '../constants';
var viewerScriptRaven;
export function configureWorkerRaven(platformServices, userContext) {
    viewerScriptRaven = platformServices.monitoring.createMonitor(VIEWER_SCRIPT_DSN, function (data) {
        data.environment = 'Worker';
        return data;
    });
    viewerScriptRaven.setUserContext(userContext);
}
export var wrapTryCatch = function (onCatch) { return function (fn) {
    //tslint:disable-next-line:only-arrow-functions
    return function () {
        try {
            return fn.apply(null, arguments);
        }
        catch (e) {
            onCatch && onCatch(e);
        }
    };
}; };
export var viewerScriptErrorReporter = function (e) {
    viewerScriptRaven && viewerScriptRaven.captureException(e);
    throw e;
};
export function withViewerScriptErrorReporting(obj) {
    return withErrorReporting(viewerScriptErrorReporter)(obj);
}
export function withErrorReporting(errorReporterFn) {
    return function (obj) {
        var wrapper = wrapTryCatch(errorReporterFn);
        return _.reduce(obj, function (result, value, key) {
            var _a;
            return (tslib_1.__assign({}, result, (_a = {}, _a[key] = _.isFunction(value) ? wrapper(value) : value, _a)));
        }, {});
    };
}
export function createFakeRaven() {
    return function (_dsn) { return _.noop; };
}
export function createControllerRaven(platformServices, userContext) {
    return function (dsn) {
        var raven = platformServices.monitoring.createMonitor(dsn, function (data) {
            data.environment = 'Worker';
            return data;
        });
        raven.setUserContext(userContext);
        return function (ex, options) {
            raven.setExtraContext(ex);
            raven.captureException(ex, options);
            raven.setExtraContext();
            throw ex;
        };
    };
}
//# sourceMappingURL=errorReporter.js.map